import { SnackbarProvider } from "notistack";
import { BrowserRouter } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { store, StoreProvider } from "./store";
import Router from "./router";

const darkTheme = createTheme({
  palette: {
    mode: "dark",
    background: {
      paper: "#212428",
      default: "#1D1E24",
    },
  },
});

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider theme={darkTheme}>
        <CssBaseline />
        <SnackbarProvider>
          <StoreProvider value={store}>
            <Router />
          </StoreProvider>
        </SnackbarProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
